import * as React from 'react';
import { SectionPanel } from 'ui/section-panel/section-panel';
import { MainGridContainer } from 'ui/common/main-grid-container/main-grid-container';
import { CodetableItemFormComponentProps } from 'app/area/codetable/item/codetable-item-form';
import { SlotProps } from 'app/area/codetable/item/types';
import { renderSlot } from 'app/area/codetable/item/screen-renderer/render-slot';

export const UnitOfMeasureDetails = (props: Partial<CodetableItemFormComponentProps> & SlotProps) => {

  const { sectionSlots, sectionRef, translation } = props;

  return <div ref={sectionRef}>
    <SectionPanel
      className="admin-paper-top-panel"
      componentId="uom-details"
      validation={undefined}
      info={{ text: translation.uom_details }}
      label={{ visible: true, text: translation.uom_details }} />
    <MainGridContainer>
      <div className="row">
        {renderSlot(sectionSlots, 'top', props)}
      </div>
    </MainGridContainer>
  </div>;
};
